import { useCallback } from 'react';
import { isWeb } from 'shared/src/utils';
import { useMoveToWebview } from 'shared/src/utils/navigator/useCommonNavigator/moveToWebview';
import {
  appendParams,
  finalizeUrl,
  getDefaultWebviewLink,
} from 'shared/src/utils/navigator/utils';
import { useOpenDeeplink } from 'shared/src/hooks';

/**
 * 무물라이브 프로필/콘텐츠 웹뷰 랜딩.
 * - 웹: `https://m.a-bly.com/{path}`
 * - 앱: `ably://webview?title_bar=false&url={encodeURIComponent(path)}`
 */
export const useOnPressMumulLiveContent = (profileSno: number | null) => {
  const { openDeeplink } = useOpenDeeplink();
  const moveToWebview = useMoveToWebview();

  const moveTo = useCallback(
    (path: string) => {
      if (isWeb) {
        moveToWebview(`/${path}`);
        return;
      }
      const link = getDefaultWebviewLink(false);
      appendParams(link, 'url', path);
      openDeeplink(finalizeUrl(link));
    },
    [moveToWebview, openDeeplink],
  );

  const onPressProfile = useCallback(() => {
    if (profileSno == null) return;
    moveTo(`mumul-live/profiles/${profileSno}`);
  }, [moveTo, profileSno]);

  const onPressPost = useCallback(
    (postSno: number) => {
      if (profileSno == null) return;
      moveTo(
        `mumul-live/profiles/${profileSno}/posts?start_post_sno=${postSno}`,
      );
    },
    [moveTo, profileSno],
  );

  return { onPressProfile, onPressPost };
};
